<template>
  <div class="fixed flex justify-center align-middle w-full h-full bg-[#091625e6] z-10">
    <div class="flex flex-col justify-center align-middle text-center w-full text-white">
      <div class="w-full flex justify-center">
        <TwcSpinner color="text-white" />
      </div>
      <h5 class="text-xl font-medium">{{ message }}</h5>
    </div>
  </div>
</template>

<script setup lang="ts">
import { TwcSpinner } from 'transit-web-components'
import { ref, onMounted } from 'vue'
import { useOrderStore } from '@/stores/order'

const orderStore = useOrderStore()
const createIndividualPasses = ref(orderStore.createIndividualPasses)
const passesQuantity = ref(orderStore.passesQuantity)
const message = ref('Processing...')

onMounted(() => {
  if (createIndividualPasses.value && passesQuantity.value > 1) {
    setTimeout(() => {
      message.value = `Generating ${passesQuantity.value} passes...`
    }, 3000)
  }
})
</script>

<style></style>
